import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  appInsights: ApplicationInsights;
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.INSTRUMENTATION_KEY,
        enableAutoRouteTracking: false // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, action: 'READ' | 'UPDATE' | 'DELETE' | 'CREATE', properties?: { [key: string]: any }) {
    const props = {
      ...properties,
      action: action
    }
    this.appInsights.trackEvent({ name: name}, props);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message}, properties);
  }
  clearAuthenticatedUserContext(){
     this.appInsights.clearAuthenticatedUserContext();

  }

  setAuthenticatedUserContext(userId){
    this.appInsights.setAuthenticatedUserContext(userId);
 }

}
